import { render, staticRenderFns } from "./my_book_publication_data.vue?vue&type=template&id=5379e6a7"
import script from "./my_book_publication_data.vue?vue&type=script&lang=js"
export * from "./my_book_publication_data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports